export default {
    title: 'Organisationen',
    id: 'ID',
    organisation_name: 'Organisation',
    role_name_de: 'Rolle',
}